import Step1 from "./select-1.png";
import Step2 from "./select-2.png";
import Step3a from "./select-3a.png";
import Step3b from "./select-3b.png";

const selectImg = [
  { id: "Step1", imageName: Step1, imageDesc: "Select Step 1" },
  { id: "Step2", imageName: Step2, imageDesc: "Select Step 2" },
  { id: "Step3a", imageName: Step3a, imageDesc: "Select Step 3a" },
  { id: "Step3b", imageName: Step3b, imageDesc: "Select Step 3b" },
];

export default selectImg as HelpImage[];
